import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import type { IAdminUserROO1 } from 'api'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { AdminRole } from '@/constants/adminRole'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { toast } from '@/lib/toast'

export default function UserAdminEdit() {
  const navigate = useNavigate()
  const id = useQueryValue('id', '')
  const [isPasswordChange, setIsPasswordChange] = useState(id ? false : true)

  const { data } = useApi({
    id: 'adminDetail',
    fn: api().admin.getAdmin,
    params: id,
    enabled: !!id,
  })

  const onSave = async (data: IAdminUserROO1) => {
    if (isPasswordChange && data.password === '') {
      alert('비밀번호를 입력해주세요.')
      return
    }

    if (id) {
      await api().admin.updateAdmin(id, {
        password: isPasswordChange ? data.password : undefined,
        name: data.name,
        username: data.username,
        role: data.role,
      })
    } else {
      await api().admin.createAdmin({
        username: data.username,
        name: data.name,
        password: data.password ?? '',
        passwordConfirm: data.password ?? '',
        role: data.role,
      })
    }
    toast.success('관리자 수정을 완료하였습니다.')
    navigate(`/admin`, { replace: true })
  }

  const onDelete = async () => {
    if (id) {
      await api().admin.deleteAdmin(id)
    }
    navigate(`/admin`, { replace: true })
  }

  return (
    <ContentDetailView
      title={id ? '관리자 수정' : '관리자 생성'}
      data={data}
      onSave={onSave}
      onDelete={onDelete}
      hideSaveToast={() => true}
    >
      <DetailForm
        data={data}
        fields={[
          {
            label: '아이디',
            key: 'username',
            type: FormFieldType.STRING,
            required: true,
            readOnly: !!id,
          },
          {
            label: '이름',
            key: 'name',
            type: FormFieldType.STRING,
            required: true,
          },
          {
            label: '역할',
            key: 'role',
            type: FormFieldType.SELECT,
            required: true,
            options: [
              { label: '슈퍼 관리자', value: AdminRole.SUPER_ADMIN },
              { label: '파트너 관리자', value: AdminRole.PARTNER_ADMIN },
            ],
          },
          {
            label: '비밀번호',
            key: 'password',
            type: FormFieldType.CUSTOM_READ_ONLY,
            required: !id || isPasswordChange,
            render(data, context) {
              return (
                <div className="flex items-center gap-2">
                  {(!id || isPasswordChange) && (
                    <Input
                      {...context?.register('password')}
                      className="w-full"
                      type="password"
                      autoComplete="new-password"
                      placeholder="새 비밀번호를 입력하세요"
                      key={
                        isPasswordChange ? 'password-change' : 'password-hidden'
                      }
                    />
                  )}
                  {id && !isPasswordChange && (
                    <Button
                      onClick={() => {
                        setIsPasswordChange(true)
                        context?.setValue('password', '')
                      }}
                      type="button"
                    >
                      비밀번호 변경
                    </Button>
                  )}
                </div>
              )
            },
          },
        ]}
      />
    </ContentDetailView>
  )
}
